import Vue from "vue";
import Router from "vue-router";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: "/",  //首页
      name: "home",
      component: () => import("@/views/home"),
    },
    {
      path: "/about",  //企业简介
      name: "about",
      component: () => import("@/views/about"),
    },
    {
      path: "/solution",  //解决方案
      name: "solution",
      component: () => import("@/views/solution"),
    },
    {
      path: "/case",  //工程案例
      name: "case",
      component: () => import("@/views/case"),
    },
    {
      path: "/caseDetail",  //工程案例详情
      name: "caseDetail",
      component: () => import("@/views/caseDetail"),
    },
    {
      path: "/product",  //产品中心
      name: "product",
      component: () => import("@/views/product"),
    },
    {
      path: "/productDetail",  //产品中心详情
      name: "productDetail",
      component: () => import("@/views/productDetail"),
    },
    {
      path: "/news",  //新闻资讯
      name: "news",
      component: () => import("@/views/news"),
    },
    {
      path: "/newsDetail",  //新闻资讯详情
      name: "newsDetail",
      component: () => import("@/views/newsDetail"),
    },
    {
      path: "/contact",  //联系我们
      name: "contact",
      component: () => import("@/views/contact"),
    },
    {
      path: "/honor",  //荣誉资质
      name: "honor",
      component: () => import("@/views/honor"),
    },
    {
      path: "/achieve",  //企业业绩
      name: "achieve",
      component: () => import("@/views/achieve"),
    },
    {
      path: "/video",  //视频
      name: "video",
      component: () => import("@/views/groupVideo"),
    },
  ],
});
